import { Code, Hint, Link, Radio } from '@lokalise/louis';

interface FilenamesCustomRadioProps {
    isLimitedFileStructure: boolean;
}

const FilenamesCustomRadio = ({ isLimitedFileStructure }: FilenamesCustomRadioProps) => (
    <Radio value="filenamesCustom">
        {isLimitedFileStructure ? 'All keys to a single file' : 'One file per language. Bundle structure:'}{' '}
        <Hint placement="right">
            {isLimitedFileStructure ? (
                <>
                    All keys are exported into default filename by selected file format.{' '}
                    <Link target="_blank" rel="noreferrer" href="https://developers.lokalise.com/docs/webhooks-guide">
                        Learn more
                    </Link>
                    .
                </>
            ) : (
                <>
                    Recommended option. Configure bundle structure using placeholders. You can use{' '}
                    <Code>%LANG_ISO%</Code>, <Code>%LANG_NAME%</Code>, <Code>%FORMAT%</Code> and{' '}
                    <Code>%PROJECT_NAME%</Code> as specifiers.{' '}
                    <Link target="_blank" rel="noreferrer" href="https://developers.lokalise.com/docs/webhooks-guide">
                        Learn more
                    </Link>
                    .
                </>
            )}
        </Hint>
    </Radio>
);

export default FilenamesCustomRadio;
